// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonLanguage_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5133 15.9995H13.0816L12.2742 13.8611H9.5671L8.8262 15.9995H6.39453L9.84078 7.2417H12.1145L15.5133 15.9995ZM12.0077 12.3888L11.0934 9.52733C11.0261 9.31361 10.9786 9.05833 10.9509 8.76149H10.9035C10.8837 9.01083 10.8342 9.2582 10.755 9.50358L9.82891 12.3888H12.0077Z" class="svg-bg"/>
  <path d="M6 0H4V1.9988L0 1.9988V3.9988L10 3.9988V1.9988L6 1.9988V0ZM7.89666 9.45129C7.34641 9.20888 6.83614 8.89239 6.37848 8.51446 7.31506 7.23459 7.90233 5.68298 7.99995 4H5.99546C5.91296 5.08465 5.56425 6.09489 5.01453 6.96553 4.46481 6.09489 4.1161 5.08465 4.03359 4H2.02911C2.12673 5.68298 2.714 7.23459 3.65058 8.51446 2.89234 9.14062 1.98967 9.59811 1.00002 9.82949V11.8707C2.51424 11.6037 3.89025 10.936 5.01453 9.9809 5.656 10.5258 6.3794 10.9772 7.16368 11.314L7.89666 9.45129Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonLanguage is a generated icon component.
 */
let IconCommonLanguage = IconCommonLanguage_1 = class IconCommonLanguage extends IconBaseElement {
    render() {
        return html `${IconCommonLanguage_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonLanguage.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonLanguage = IconCommonLanguage_1 = __decorate([
    customElement('zui-icon-common-language')
], IconCommonLanguage);
export { IconCommonLanguage };
